/**
 * コモンクラス
 * @constructor
 */
 class Search {
    constructor() {
  
    }
  
    init() {
        $('.js-searchClick').on('click', function () {
          if($('.js-searchIcon').hasClass('active') == false){
            $('.js-searchIcon').attr('src', '/hatarakikata/assets/img/common/search_close.svg').addClass('active');
              $('.js-searchBox').fadeIn(100);
          }else{
            $('.js-searchIcon').attr('src', '/hatarakikata/assets/img/common/search.svg').removeClass('active');
            $('.js-searchBox').fadeOut(100);
          }
      })
  
    }
  
  }
  
  export default Search;
  